import { Box, InputAdornment } from "@mui/material";
import { ValidatedDateInput, ValidatedNumberInput } from "../../../../../../common/inputs/ValidatedInputs";
import EntityEditor from "../../../../../../common/Tables/EntityEditor";

const ratePlanEditorStyle = ({ theme }) => ({
    '& .MuiPaper-root': {
        minWidth: '300px',
        maxWidth: '500px'
    }
});

const emptyPayment = {
    id: null,
    dueDate: null,
    paidDate: null,
    amountDue: 0,
    orderId: null
};

const PaymentEditor = ({ onSuccess, onClose, editedPayment, existingPayments, defaultAmountDue, defaultDueDate }) => {
    const defaultPayment = editedPayment || {
        ...emptyPayment,
        amountDue: defaultAmountDue,
        dueDate: defaultDueDate
    };

    const isEditing = !!editedPayment;

    const title = isEditing ? 'Editing payment' : "Creating a new payment";

    const updatePayment = (payment) => {
        return payment;
    }

    const createPayment = (payment) => {
        payment.id = existingPayments ? `new-${existingPayments.length + 1}` : `new`;
        return payment;
    }

    const EditorContent = ({ entity, onChange, disabled, entityChanged}) => {
        const payment = entity;

        return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', paddingTop: '10px' }}>
            <ValidatedDateInput
                id='dueDate'
                label="Due date"
                value={payment.dueDate}
                onChange={onChange}
                required
                disabled={disabled}
                textFieldProps={{
                    size: 'small',
                    sx: {
                        width: '220px'
                    }
                }}
                disableError={!entityChanged}
            />
            <ValidatedNumberInput
                margin="dense"
                id={`amountDue`}
                label={'Amount due'}
                min={0}
                required
                onChange={onChange}
                disabled={disabled}
                sx={{ width: "120px" }}
                value={payment.amountDue}
                size="small"
                InputProps={{
                    endAdornment: <InputAdornment position="end">zł</InputAdornment>,
                }}
                hideButtons
                disableError={!entityChanged}
            />
            <ValidatedDateInput
                id='paidDate'
                label="Paid date"
                value={payment.paidDate}
                onChange={onChange}
                disabled={disabled}
                textFieldProps={{
                    size: 'small',
                    sx: {
                        width: '220px'
                    }
                }}
                disableError={!entityChanged}
            />
        </Box>;
    }

    return <EntityEditor
        dialogProps={{ sx: ratePlanEditorStyle }}
        title={title}
        defaultEntity={defaultPayment}
        entityName='Payment'
        submitAction={isEditing ? updatePayment : createPayment}
        editing={isEditing}
        onClose={onClose}
        onSuccess={onSuccess}
        EditorContent={EditorContent}
    />

}

export default PaymentEditor;